import { formatCountdown, secondsUntil, useTick } from "../lib/time";

interface Props {
  expiresAt: string;
  className?: string;
}

export function Countdown({ expiresAt, className = "" }: Props) {
  const now = useTick(1000);
  const seconds = secondsUntil(expiresAt, now);
  const expired = seconds <= 0;
  const critical = seconds > 0 && seconds <= 300; // < 5 min

  const color = expired
    ? "text-ink-500"
    : critical
      ? "text-danger-400"
      : "text-ink-200";

  return (
    <span
      className={`font-mono tabular-nums ${color} ${critical ? "animate-pulse-slow" : ""} ${className}`}
    >
      {formatCountdown(seconds)}
    </span>
  );
}
